import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavParams } from '@ionic/angular';
import { HelperService } from 'src/app/core/services/helper.service';
import { Storage } from '@ionic/storage';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { SearchService } from 'src/app/core/services/search.service';

@Component({
  selector: 'app-cart-list',
  templateUrl: './cart-list.page.html',
  styleUrls: ['./cart-list.page.scss'],
})

export class CartListPage implements OnInit {
  
  apiCatalog: any = [];
  apiCatalogData: any = [];
  cartId: string = '';
  imagePath: any;
  loader: boolean = false;
  selectedAPI: any;
  isSelected: any = false;
  dataType: any;

  constructor(
    public modalCtrl: ModalController,
    private navParams: NavParams,
    public helperService: HelperService,
    public storage: Storage,
    private backendService: BackendService,
    private searchService: SearchService,
    private router: Router
  ) {

    this.dataType = this.navParams.get('dataType');

    if (this.dataType == 'source') {
      const cartId = this.navParams.get('sourceCartId');
      //console.log(cartId);
      if (cartId) {
        this.cartId = cartId;
      }
    }

    if (this.dataType == 'operations') {
      const cartId = this.navParams.get('opsCartId');
      if (cartId) {
        this.cartId = cartId;
      }
    }

    if (this.dataType == 'target') {
      const cartId = this.navParams.get('targetCartId');
      if (cartId) {
        this.cartId = cartId;
      }
    }
     
  }

  ngOnInit() {
    this.getCartDetails();
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  async getStorage() {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id"),
      showDialog: await this.storage.get("showDialog")
    }
    return data;
  }

  getCartDetails() {
    this.helperService.loader();
    this.getStorage().then((storage) => {
      let payload = {
        user_id: storage.userId
      };
      this.backendService
        .PostAPICall('cartDetails', payload, storage.token)
        .subscribe(
          (data) => {
            if (data) {
              this.processCartDetails(data);
            } else {
              this.processEmptyCart();
            }
          },
          (error) => {
            //console.log(error);
            this.processEmptyCart();
            this.handleError();
          }
        );
    });
  }

  processCartDetails(data: any) {
    this.apiCatalogData = this.filterDataByType(data);
    this.apiCatalog = this.apiCatalogData.map((item) => ({ ...item, isSelected: false }));
    this.updateSelectedData();

    this.loader = true;
    this.helperService.closeLoader();
    this.imagePath = data.image;
    this.searchService.sendCartCount(data.length);
    this.helperService.closeLoader();
  }

  processEmptyCart() {
    this.searchService.sendCartCount(0);
    this.apiCatalog = [];
    this.loader = true;
    this.helperService.closeLoader();
  }

  filterDataByType(data: any) {
    if (this.dataType === 'source') {
      return data.filter((item) => item.api_type === 1);
    } else if (this.dataType === 'operations') {
      return data.filter((item) => item.api_type === 3);
    } else if (this.dataType === 'target') {
      return data.filter((item) => item.api_type === 3);
    }
    return [];
  }

  updateSelectedData() {
    if (this.cartId) {
      this.apiCatalog.forEach((item) => {
        if (item.ID === this.cartId) {
          item.isSelected = true;
        }
      });
    }
  }

  handleError() {
    this.helperService.presentToast('Oops! something went wrong', 2000);
  }

  catalogDetails(id) {
    this.router.navigate(['baseapp/marketplace/details/', id]);
  }

  selectedCartData(cartData: any) {
    cartData.isSelected = true;
    let selectedCartData: any = { data: cartData };
    this.modalCtrl.dismiss(null, selectedCartData);
  }

}
